import { render, staticRenderFns } from "./iqalacomments.vue?vue&type=template&id=0de09b7a"
import script from "./iqalacomments.vue?vue&type=script&lang=js"
export * from "./iqalacomments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports